import { TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

interface TableHeaderProps {
  tableHeaders?: any[];
  handleSortRequest?: (column: string) => void;
  filters?: any;
}

export default function TableHeader({
  tableHeaders,
  handleSortRequest,
  filters,
}: TableHeaderProps) {
  const renderLabel = (header: any) => {
    const labelContent = typeof header.label === 'string' ? t(header.label) : header.label;

    if (header.sortable && handleSortRequest) {
      return (
        <TableSortLabel
          active={filters?.sort?.orderBy === header.sortKey}
          direction={filters?.sort?.orderBy === header.sortKey ? filters?.sort?.order : 'asc'}
          onClick={() => handleSortRequest(header.sortKey)}
          hideSortIcon
        >
          {labelContent}
        </TableSortLabel>
      );
    }

    return labelContent;
  };

  return (
    <TableHead>
      <TableRow>
        {tableHeaders?.map((header: any, index: number) => (
          <TableCell
            key={index}
            align={header.align || 'left'}
            width={header.width || 'auto'}
            sx={{ fontWeight: 'bold' }}
          >
            {renderLabel(header)}
          </TableCell>
        ))}
      </TableRow>
      {tableHeaders?.length === 0 && (
        <TableRow>
          <TableCell colSpan={100} align="center">
            {t('No data available')}
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
}
